import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'

import { toggleClass } from '../utils/dom'

const ACTIVE = 'is-active'
const CLICK = 'Button--click-effect'

export default class ButtonClick extends Component {

    constructor(element) {
        super(element)
        this.timer = null
    }

    prepare() {
        this.element.addEventListener('click', ::this.effect)
    }
    
    effect(event) {
        event.preventDefault()
        this.element.classList.add(CLICK)
        setTimeout(() => {
            this.element.classList.remove(CLICK)
        }, 1000)
    }
}
